import React, { Fragment } from 'react';
import styled from 'styled-components';
import I10n from '../../features/i10n';
import Toggle from '../toggle';
import MsxIcons from '../../features/msx-icons';
import LicenseSelectorPackageSummary from './license_selector_package_summary';
import ProductInformationCache from '../../persistence/description-cache';
import { SECONDARY_COLOR } from '../../color-constants';
import LicenseSelectorPackageSummaryContent from './license_selector_package_summary_content';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  flex: 1 1 0px;
  padding: 10px 20px 0px 20px;
  background-color: #F4F4F4;
`;

const ServicePlanCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right : 20px;
  flex: 1 1 0px;

  @media (max-width: 800px) {
    margin-right : 0px;
  }
`;

const ServicePlanCard = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
`;

const ServicePlanCardHeader = styled.div`
  display: flex;
  flex-direction: column;
`;

const ServicePlanTitle = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 32px;
  color: rgba(0, 0, 0, 0.8);
  margin-bottom: 20px;
  font-weight: 700;
  margin-top: 10px;
`;

const ToggleWrapper = styled.div`
  display: flex;
  padding-top: 5px;
`;

const ServicePlanTitleSubtitle = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.8);
  margin-bottom: 20px;
  font-weight: 700;
  margin-top: 10px;
`;

const SelectedLicence = styled.div`
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 20px;
`;

const ServicePlanRow = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0px;
  background-color: #f4f4f4;
  border-bottom: 1px solid #D9D9D9;
`;

const LicenseSelectorPackageSummaryWrapper = styled.div`
  display: flex;
  min-width: 410px;
  width: 410px;
  max-width: 410px;
  max-height: 100%;

  @media (max-width: 800px) {
    display: none;
  }
`;

const CheckIconWrapper = styled.div`
  margin-right: 10px;
  margin-left: 10px;
  color: ${SECONDARY_COLOR};
  color: var(--se-primary, ${SECONDARY_COLOR});
`;

const MobilePackageSummaryPositioner = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  display: none;
  flex-direction: column;
  pointer-events: none;

  @media (max-width: 800px) {
    display: flex;
  }
`;

const MobilePackageSummaryContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  background: white;
  flex: 0 0 0px;
  pointer-events: auto;
  padding: 0px 10px;
  ${props => props.$isOpen ? 'flex: 1 1 0px;' : ''}

  transition: all 0.5s;
`;


class ServicePlanScreenContent extends React.Component {

  render = () => {
    return (
      <>
        <MobilePackageSummaryPositioner>
          <MobilePackageSummaryContentWrapper $isOpen={this.props.mobilePackageSummaryOpen}>
            {this.props.mobilePackageSummaryOpen && <LicenseSelectorPackageSummaryContent
              licenseGroups={this.props.licenseGroupsForSummary}
              isOpen={true}
              canOptimize={false}
              optimizeLicenses={false}
              disabled={this.props.isSaving}
              onOptimizeChange={() => {}}
              removeSoftwareLicence={this.props.removeSoftwareLicence}
              actionButtons={[{
                action: () => {
                  this.props.onContinue();
                },
                importance: 'emphasized',
                label: I10n.get('app.action.continue')
              }]}
              onClear={() => {
                this.props.openModal({
                  modalType: 'confirmation',
                  modalProps: {
                    onCancel: () => { this.props.closeModal(); },
                    onSubmit: () => {
                      this.props.closeModal();
                      this.props.clearSoftwareLicenses();
                    },
                    title: I10n.get('screen.licence_selector.switch_license_model_modal_clear.title'),
                    text: I10n.get('screen.licence_selector.switch_license_model_modal_clear.body'),
                    cancelText: I10n.get('app.action.cancel'),
                    submitText: I10n.get('app.action.continue'),
                  }
                });
              }}
            >
            </LicenseSelectorPackageSummaryContent>}
          </MobilePackageSummaryContentWrapper>
        </MobilePackageSummaryPositioner>
        <Wrapper>
          <ServicePlanCardWrapper>
            {this.props.servicePlanItems.map((servicePlanItem, idx) => {
              return (
                <ServicePlanCard key={idx}>
                  <ServicePlanCardHeader>
                    <ServicePlanTitle>
                      {I10n.getOrDefault(`screen.service_plan.${servicePlanItem.labelKey}.title`, servicePlanItem.title ? servicePlanItem.title : I10n.get('screen.service_plan.default.title'))}
                      <ToggleWrapper>
                        <Toggle
                          disabled={this.props.isSaving}
                          active={this.props.servicePlanActivated}
                          onToggle={() => {
                            this.props.setServicePlanActivationServicePlanScreen(!this.props.servicePlanActivated);
                          }}
                        />
                      </ToggleWrapper>
                    </ServicePlanTitle>
                  </ServicePlanCardHeader>
                  <SelectedLicence>
                    {ProductInformationCache.getDescription(servicePlanItem.id) || servicePlanItem.id}
                  </SelectedLicence>
                  {servicePlanItem.servicePlanAssets.map((asset, index) => {
                    return (<Fragment key={index}>
                      <ServicePlanTitleSubtitle>{I10n.getOrDefault(`screen.licence_selector.service_plan_asset.name.${asset.labelKey}`, asset.value)}</ServicePlanTitleSubtitle>
                      {asset.servicePlanAssetItems.map((item, index) => {
                        return (
                          <ServicePlanRow key={index}>
                            <CheckIconWrapper>
                              <MsxIcons name="done-stroke"></MsxIcons>
                            </CheckIconWrapper>
                            {I10n.getOrDefault(`screen.licence_selector.service_plan_asset_item.name.${item.labelKey}`, item.value)}
                          </ServicePlanRow>
                        );
                      })}
                    </Fragment>);
                  })}
                </ServicePlanCard>
              );
            })}
          </ServicePlanCardWrapper>
          <LicenseSelectorPackageSummaryWrapper>
            <LicenseSelectorPackageSummary
              licenseGroups={this.props.licenseGroupsForSummary}
              licenseModel={this.props.licenseModel}
              availableLicenseModels={this.props.softwareInfo?.availableLicenseModels || []}
              removeSoftwareLicence={this.props.removeSoftwareLicence}
              onClear={() => {
                this.props.openModal({
                  modalType: 'confirmation',
                  modalProps: {
                    onCancel: () => { this.props.closeModal(); },
                    onSubmit: () => {
                      this.props.closeModal();
                      this.props.clearSoftwareLicenses();
                    },
                    title: I10n.get('screen.licence_selector.switch_license_model_modal_clear.title'),
                    text: I10n.get('screen.licence_selector.switch_license_model_modal_clear.body'),
                    cancelText: I10n.get('app.action.cancel'),
                    submitText: I10n.get('app.action.continue'),
                  }
                });
              }}
              disabled={this.props.isSaving}
            />
          </LicenseSelectorPackageSummaryWrapper>
        </Wrapper>
      </>
    );
  }
}

export default ServicePlanScreenContent;
